import { CommonModule, Location } from "@angular/common";
import {
    afterNextRender,
    Component,
    computed,
    inject,
    OnDestroy,
} from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { AlertService, Icon, PageModalContainer } from "@malirang/front-share";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { CenterStore } from "../../../../stores/center/center.store";
import { CenterRoleStore } from "../../../../stores/center/role.store";
import { UserStore } from "../../../../stores/user.store";
import { DocumentSideSection } from "./document-side-section/document-side-section";
import { DocumentStore } from "../store/document.store";

@Component({
    selector: "app-document",
    templateUrl: "./document.layout.html",
    styleUrls: ["./document.layout.css"],
    imports: [
        CommonModule,
        RouterOutlet,
        PageModalContainer,
        Icon,
        DocumentSideSection,
    ],
})
export class DocumentLayout implements OnDestroy {
    readonly router = inject(Router);
    readonly location = inject(Location);
    readonly documentStore = inject(DocumentStore);
    readonly centerRoleStore = inject(CenterRoleStore);
    readonly centerStore = inject(CenterStore);
    readonly alertService = inject(AlertService);
    readonly userStore = inject(UserStore);

    currentUser = this.userStore.user;
    currentCenter$ = this.centerStore.currentCenter$;
    currentTicket = this.documentStore.currentTicket;
    navigationEnd$ = injectNavigationEnd();
    ticketId = injectQueryParams("ticketId");
    type = injectQueryParams("type");

    read = computed(
        () =>
            this.centerRoleStore.documentRead() ||
            this.centerRoleStore.documentManageSelf(),
    );
    platform = Capacitor.getPlatform();

    constructor() {
        afterNextRender(() => {
            this.navigationEnd$.subscribe({
                next: () => {
                    this.handleGuard();

                    if (!this.ticketId()) {
                        this.documentStore.setTicketId(null);
                    }
                },
            });

            this.handleGuard();
        });
    }

    handleGuard() {
        if (this.centerRoleStore.myRole()) {
            if (this.currentUser() && this.currentUser() && !this.read()) {
                this.alertService
                    .open({
                        title: "권한 없음",
                        content:
                            "문서 열람 권한이 없습니다. 관리자에게 문의하세요.",
                        type: "warning",
                        buttons: {
                            cancel: {
                                hidden: true,
                            },
                            confirm: {
                                color: "yellow",
                            },
                        },
                    })
                    .closed.subscribe({
                        next: () => {
                            this.documentStore.goBack();
                        },
                    });
            }
        }
    }

    ngOnDestroy(): void {
        this.documentStore.setTicketId(null);
    }
}
